export const h = {
  set_up: "创建账户",
  Email: "请输入邮箱",
  pwd: "请输入密码",
  c_pwd: "请再次输入密码",
  v_code: "验证码",
  s_code: "发送验证码",
  regist: "注册",
  have_an_account: "已有账户？点我登录",
  login:'登录',
  create_an_account:"创建账户",
  forget_password:"忘记密码？"
}